import { GradingScheme } from 'app/library/grading-scheme/models/grading-scheme.model';

export class FetchGradingSchemeByModuleIdSuccess {
    static readonly type = '[GradingScheme] FetchGradingSchemeByModuleIdSuccess';

    constructor(
        public payload: {
            gradingScheme: GradingScheme;
        }
    ) {}
}
